import Api from "../../../../../constants/Api";
import axiosInstance from "../../../../../services/AxiosInstance";
import { isNoOpenCashError } from "../../../../../utils/CashErrorUtils";
import { warnAlertYesOrNo } from "../../../alert/defaultAlert";
import { ApiError } from "../../../Common/ApiError";

/**
 * Saída padrão para a recusa por falta de caixa aberto: pergunta se a pessoa quer abrir um
 * caixa com saldo zero na filial e, abrindo, repete a operação.
 *
 * Usada pela finalização da venda, pelo consumo do colaborador (lançamento e recebimento) e
 * pelo pagamento de mensalidade por fora. Antes cada tela tinha a própria cópia deste passo a
 * passo. Quem chama decide o texto da pergunta, a observação gravada na abertura e o que
 * repetir.
 *
 * @param {object} params
 * @param {*} params.error erro devolvido pela API
 * @param {number} params.branchId filial onde o caixa será aberto; sem ela não há o que oferecer
 * @param {string} params.question pergunta exibida ao operador
 * @param {string} params.openingNote observação gravada no caixa aberto automaticamente
 * @param {function} params.onBeforeAsk tira o modal de quem chamou da frente do alerta
 * @param {function} params.onOpened repete a operação depois de o caixa abrir
 * @param {function} params.onDeclined devolve a tela ao estado anterior se a pessoa desistir
 * @returns {boolean} true quando o erro era falta de caixa e foi tratado aqui; false para quem
 *          chamou tratar o erro do jeito dele
 */
export const offerToOpenCash = ({ error, branchId, question, openingNote, onBeforeAsk, onOpened, onDeclined }) => {
    if (!isNoOpenCashError(error) || !branchId) {
        return false;
    }

    // O modal de quem chamou sai da frente para o alerta aparecer (senão o SweetAlert fica
    // atrás do modal Bootstrap), e volta pelo onDeclined se a pessoa desistir. A espera dá
    // tempo de o modal terminar de fechar; sem modal para tirar da frente, pergunta na hora.
    onBeforeAsk?.();
    window.setTimeout(() => {
        warnAlertYesOrNo(question, () => {
            axiosInstance.post(Api.cash_flow.cash, {
                openingBalance: 0,
                branch: { id: branchId },
                obs: openingNote
            })
                .then(() => onOpened())
                .catch(openCashError => {
                    ApiError(openCashError);
                    onDeclined?.();
                });
        }, () => onDeclined?.());
    }, onBeforeAsk ? 200 : 0);
    return true;
};

export default offerToOpenCash;
